module.exports = {
  ChartingColors: {
    Sequential: [
      "#A7ABFE",
      "#BDC0FE",
      "#D3D5FF",
      "#9BF5FE",
      "#CDFAFF",
      "#E6FDFF",
      "#CCCCCC",
      "#DBDBDB",
    ],
    Categorical: [
      "#7379FD",
      "#0B16FC",
      "#9BF5FE",
      "#02B8CA",
      "#A9ECD3",
      "#22966B",
      "#FED28D",
      "#F59602",
      "#EEFE92",
      "#A9C602",
      "#F79E94",
      "#F04B38",
      "#8DBAFE",
      "#0263F5",
    ],
  },
};
